














































import { Component, Vue } from "vue-property-decorator";
import { UsersService } from "@/services/api/users.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { Getter } from "vuex-class";
import { CurrentUser } from "@/models/auth/current.user";
import { SecurityUserCommand } from "@/server/app.commands";

@Component
export default class AccountSecurityPage extends Vue {
  @Getter("identity") identity!: CurrentUser;
  usersService: UsersService = new UsersService();
  command: SecurityUserCommand = new SecurityUserCommand();
  pwdConfirm: string = "";
  isLoading: boolean = false;
  isValid: boolean = false;

  onChangePassword(): void {
    if (this.isLoading) return;
    this.isLoading = true;
    this.usersService
      .ChangePassword(this.command)
      .then(() => {
        this.clearForm();
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "A sua senha foi alterada com sucesso"
        );
      })
      .catch((error: any) => {
        NotificationServiceBus.showError(error);
      })
      .finally(() => (this.isLoading = false));
  }

  clearForm(): void {
    this.command = new SecurityUserCommand();
  }
}
